import * as React from "react";
// 消息枚举
import {
  ENoticeLevel,
  EReadStatus,
  ECollectStatus,
  EWebSiteTemplate
} from "utils/enum/notice";

// 消息提示
import { Tooltip } from "antd";

// website 登录消息模板;

interface IBaseWSTmpProps {
  // 消息分组id
  mid?: any;
  // 消息id
  id?: any;
  createTime?: any;
  // 未读 Yes:已读  No:未读
  isRead?: EReadStatus;
  // 未收藏 Yes:已收藏 No:未收藏
  isCollect?: ECollectStatus;
  // 消息级别
  isNoticeLevel?: ENoticeLevel;
  // 消息内容
  slot?: any;
  // css类
  className?: any;
  tagRead?: any;
  tagCollect?: any;
  // 消息类型
  type?: any;
}

// 基础消息模板

class BaseWSTmp extends React.Component<IBaseWSTmpProps, any> {
  state = {
    isClickRead: false,
    isClickCollect: false
  };

  constructor(props: IBaseWSTmpProps) {
    super(props);
  }

  // 设置消息级别样式
  setNoticeLevelClass = () => {
    //const { isUnread, isUnCollect, isNoticeLevel } = this.props;
    let { isNoticeLevel } = this.props;
    // debugger;
    // isNoticeLevel = isNoticeLevel || ENoticeLevel.General;
    return (
      "tmp-tag " +
      (isNoticeLevel == ENoticeLevel.General
        ? "notice__general"
        : "notice__importance")
    );
  };

  // 设置消息未读样式
  setNoticeUnReadClass = () => {
    let { isRead, type } = this.props;
    // isRead = isRead || EReadStatus.No;
    if (type != EWebSiteTemplate.TemporaryNotice)
      return isRead === EReadStatus.Yes ? "" : "unread";
    return "";
  };

  // 设置收藏样式
  setNoticeUnCollectClass = () => {
    let { isCollect } = this.props;
    // isCollect = isCollect || ECollectStatus.No;
    return isCollect === ECollectStatus.No
      ? "action-wujiaoxing uncollect"
      : "action-star collect";
  };

  // 标记为已读
  markedRead = () => {
    console.log("已读");
    const tagRead = this.props.tagRead;
    tagRead &&
      tagRead({
        id: this.props.id
      });

    this.setState({ isClickRead: true });
  };

  // 标记为已收藏
  markedCollect = () => {
    const tagCollect = this.props.tagCollect;
    tagCollect &&
      tagCollect({
        id: this.props.id
      });
  };

  // 标记为未收藏
  markedUnCollect = () => {
    const tagCollect = this.props.tagCollect;
    tagCollect &&
      tagCollect({
        id: this.props.id,
        cancel: true
      });
  };

  ref = null;
  getRef = ref => {
    console.log("baseRef", ref);
    this.ref = ref;
  };

  getContainerBody = () => {
    return this.ref || document.body;
  };

  // 渲染未读Icon
  renderUnReadIcon = () => {
    let { isRead, type } = this.props;
    if (type != EWebSiteTemplate.TemporaryNotice) {
      return isRead === EReadStatus.Yes ? (
        []
      ) : (
        <span className="unread-icon" onClick={this.markedRead} />
      );
    }
    return [];
  };

  readVisibleChange = visible => {
    visible && this.setState({ isClickRead: false });
  };

  render() {
    // 消息模板根部样式
    const noticeRootClass =
      "notice-tmp clearfix login-ws-tmp " +
      (this.props.className || "") +
      this.setNoticeUnReadClass();

    // 腿部收藏样式
    const noitceFooterClass = "action-user " + this.setNoticeUnCollectClass();

    const renderCollect = () => {
      let { isCollect, type } = this.props;
      if (type != EWebSiteTemplate.TemporaryNotice) {
        // isCollect = isCollect || ECollectStatus.No;
        if (isCollect === ECollectStatus.No) {
          return (
            <Tooltip
              placement="left"
              title="标记收藏"
              getTooltipContainer={this.getContainerBody}
            >
              <i className={noitceFooterClass} onClick={this.markedCollect} />
            </Tooltip>
          );
        } else {
          return (
            <Tooltip
              placement="left"
              title="取消收藏"
              getTooltipContainer={this.getContainerBody}
            >
              <i className={noitceFooterClass} onClick={this.markedUnCollect} />
            </Tooltip>
          );
        }
      }
      return [];
    };

    const readProps = {};
    if (this.state.isClickRead) {
      readProps["visible"] = false;
    }

    return (
      <div className={noticeRootClass} ref={this.getRef}>
        <Tooltip
          placement="left"
          title="标记已读"
          {...readProps}
          onVisibleChange={this.readVisibleChange}
          getTooltipContainer={this.getContainerBody}
        >
          {this.renderUnReadIcon()}
        </Tooltip>
        <div className="notice-header">
          <span className={this.setNoticeLevelClass()} />
          <span className="tmp-date"> {this.props.createTime}</span>
        </div>
        <div className="tmp-container" />
        {this.props.slot}
        <div className="notice-footer ">{renderCollect()}</div>
      </div>
    );
  }
}

export default BaseWSTmp;
